<template>
  <div class="v2026-professional-panel">

    <PanelCollapseBarV2026 ariaLabel="ย่อแผงข้อมูลคุณแม่บ้าน"
                           @toggleCollapse="$emit('toggleCollapse')" />

    <PanelTabBarV2026 :activeTab="activeTab" :showAi="canSeeAi" :labels="tabLabels" @setTab="setTab" />

    <PanelSubTabBarV2026 v-if="showSubTabBar"
                         :items="visibleSubTabs"
                         :activeKey="activeSubKey"
                         @select="goToSubTab" />

    <div class="v2026-pp-scroll" ref="subTabScroll">

    <div class="v2026-pp-tabpane" v-if="activeTab === 1">

    <PanelHeaderV2026 :type="1"
                      :statusIcons="headerStatusIcons"
                      :avatarUrl="avatarUrl"
                      :channelBadge="channelBadge"
                      :displayName="headerName"
                      roleLabel="คุณแม่บ้าน"
                      :subLink="regionLabel"
                      :convCustomer="convCustomer"
                      :canEdit="!!convCustomer"
                      :conversationId="selectedConversation && selectedConversation.id"
                      :customerType="selectedConversation && selectedConversation.customer_type"
                      :professional="convCustomer && convCustomer.beneat_professional"
                      :beneatUserId="convCustomer && convCustomer.beneat_user_id"
                      :beneatUserHref="headerUserHref"
                      @notify="showToast($event.variant, $event.title, $event.message)" />

    <important-message-v2026 :customer="convCustomer"
      :conversationId="selectedConversation && selectedConversation.id" />

    <UserInfoCardV2026 :type="1"
                       :idValue="providerId"
                       :systemPhone="systemPhone"
                       :systemEmail="systemEmail"
                       :chatPhone="chatPhone"
                       :chatEmail="chatEmail"
                       :convCustomer="convCustomer"
                       :canEdit="!!convCustomer"
                       :conversationId="selectedConversation && selectedConversation.id" />

    <ChatTopicSectionV2026 :chatTopic="selectedConversation && selectedConversation.chat_topic" />

    <TagsSectionV2026 :type="1" :selectedConversation="selectedConversation"
                      :tags="tags" :admin="admin" />

    <div class="v2026-pp-system">
      <span class="v2026-pp-section-label">ข้อมูลคุณแม่บ้าน</span>
      <EntityCardV2026 variant="card"
                       :avatarUrl="avatarUrl"
                       :displayName="systemName"
                       idLabel="Provider ID:"
                       :idValue="providerId"
                       :idHref="linkProfileProfessional(providerId)" />
    </div>

    <PanelStatusRowsV2026 :rows="statusRows" />

    <!-- A tile whose field is missing from the payload renders muted with "ยังไม่มีข้อมูลในระบบ". -->
    <div class="v2026-pp-stats">
      <div class="v2026-pp-card v2026-pp-stat" :class="{ 'is-muted': stat.muted }"
           v-for="stat in stats" :key="stat.label"
           v-b-tooltip.hover.top :title="stat.muted ? 'ยังไม่มีข้อมูลในระบบ' : (stat.hint || null)">
        <div class="v2026-pp-stat__top">
          <span class="v2026-pp-mask v2026-pp-stat__ico" aria-hidden="true"
                :style="maskStyle(stat.icon)"></span>
          <span class="v2026-pp-stat__label">{{ stat.label }}</span>
          <i v-if="stat.hint && !stat.muted" class="fas fa-info-circle v2026-pp-stat__hint" role="img"
             :aria-label="stat.hint"></i>
        </div>
        <div class="v2026-pp-stat__value">{{ stat.value }}</div>
      </div>
    </div>

    <ServiceBadgesV2026 :professional="pro" />

    <ChipRowV2026 label="ไม่สะดวกรับงานบ้านที่มีสัตว์เลี้ยง" :items="inconveniencePets" />
    <ChipRowV2026 label="งาน Partner" :items="partners" />

    <LimitationSectionV2026 :professionalId="proId"
                            :value="limitationText"
                            :audit="limitationAudit"
                            :adminId="admin && admin.id"
                            :adminName="(admin && admin.name) || ''"
                            @saved="onLimitationSaved" />

    </div><!-- /TAB 1 -->

    <div class="v2026-pp-tabpane v2026-pp-notes" v-if="activeTab === 2">

      <SystemNotesV2026 ref="secSystemNotes" :type="1" :entityId="proId" :admin="admin" />

      <ChatNoteV2026 ref="secChatNote" :type="1" :customer="convCustomer"
                     :conversationId="selectedConversation && selectedConversation.id" />

    </div><!-- /TAB 2 -->

    <div class="v2026-pp-tabpane v2026-pp-bookings" v-if="activeTab === 3">

      <schedule-tab-v2026 :type="1"
        :professionals="professionals" :selected-maid="selectedMaid" :schedule-month="scheduleMonth"
        :orders-by-day-map="ordersByDayMap" :selected-schedule-day="selectedScheduleDay"
        :schedule-loading="scheduleLoading" :selected-day-orders="selectedDayOrders"
        :latest-order="latestOrder" :use-calendar-component="useCalendarComponent"
        :icons="icons" :weekdays="weekdays" :calendar-cells="calendarCells" :thai-month-label="thaiMonthLabel"
        @search="onSearchMaid" @select-maid="onSelectMaid" @month-change="onCalMonthChange"
        @select-day="onCalSelectDay" @create="createBooking"
        @prev-month="prevMonth" @next-month="nextMonth" @select-cell="selectScheduleDay" />

    </div><!-- /TAB 3 -->

    <div class="v2026-pp-tabpane" v-if="activeTab === 4 && canSeeAi">
      <AiAssistantTabV2026 :selected-conversation="selectedConversation"
                           empty-text="• ไม่พบข้อมูลการสนทนา"
                           :showFunctionCalling="canSeeFunctionCalling" />
    </div><!-- /TAB 4 -->

    </div><!-- /v2026-pp-scroll -->

    <BaseToast :open="toast.open" :variant="toast.variant" :title="toast.title" :message="toast.message"
               :icon="toast.icon"
               @close="toast.open = false" />

  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import ScheduleTabV2026 from './ScheduleTabV2026.vue'
import BaseToast from './BaseToast.vue'
import ImportantMessageV2026 from './ImportantMessageV2026.vue'
import AiAssistantTabV2026 from './AiAssistantTabV2026.vue'
import PanelCollapseBarV2026 from './PanelCollapseBarV2026.vue'
import PanelTabBarV2026 from './PanelTabBarV2026.vue'
import PanelSubTabBarV2026 from './PanelSubTabBarV2026.vue'
import panelSubTabs2026 from './panelSubTabs2026'
import railFunctionCalling2026 from './railFunctionCalling2026'
import SystemNotesV2026 from './SystemNotesV2026.vue'
import TagsSectionV2026 from './TagsSectionV2026.vue'
import ChatTopicSectionV2026 from './ChatTopicSectionV2026.vue'
import ChatNoteV2026 from './ChatNoteV2026.vue'
import PanelHeaderV2026 from './PanelHeaderV2026.vue'
import UserInfoCardV2026 from './UserInfoCardV2026.vue'
import EntityCardV2026 from './EntityCardV2026.vue'
import PanelStatusRowsV2026 from './PanelStatusRowsV2026.vue'
import ServiceBadgesV2026 from './ServiceBadgesV2026.vue'
import ChipRowV2026 from './ChipRowV2026.vue'
import LimitationSectionV2026 from './LimitationSectionV2026.vue'
import { resolveStatusIcons } from '@/components/coversation/statusIconCatalog'

// One-shot per press: a collapse/expand remount must not jump back to the AI tab.
let appliedVisionToken = null

export default {
  name: 'professional-panel-v2026',
  mixins: [panelSubTabs2026, railFunctionCalling2026],
  components: {
    ScheduleTabV2026,
    BaseToast,
    ImportantMessageV2026,
    AiAssistantTabV2026,
    PanelCollapseBarV2026,
    PanelTabBarV2026,
    PanelSubTabBarV2026,
    SystemNotesV2026,
    TagsSectionV2026,
    ChatTopicSectionV2026,
    ChatNoteV2026,
    PanelHeaderV2026,
    UserInfoCardV2026,
    EntityCardV2026,
    PanelStatusRowsV2026,
    ServiceBadgesV2026,
    ChipRowV2026,
    LimitationSectionV2026
  },
  props: {
    selectedConversation: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      activeTab: 1,
      subTabScrollRef: 'subTabScroll',
      // Tab 2 only: a tab with no entry gets no strip and no spy work.
      subTabs: {
        2: [
          { key: 'sysnote', label: 'โน้ตในระบบ', refs: ['secSystemNotes'] },
          { key: 'chatnote', label: 'โน้ตแชท', refs: ['secChatNote'] }
        ]
      },
      tabLabels: {
        tab1: 'ข้อมูลคุณแม่บ้าน',
        tab2: 'โน้ต',
        tab3: 'ตารางงานแม่บ้าน',
        tab4: 'ผู้ช่วย AI'
      },
      icons: {
        chevron: require('@/assets/icons2026/arrow-right.svg'),
        line: require('@/assets/icons2026/line-color.svg'),
        facebook: require('@/assets/icons2026/facebook-color.svg'),
        point: require('@/assets/icons2026/point.svg'),
        booking: require('@/assets/icons2026/booking.svg'),
        review: require('@/assets/icons2026/c-review.svg'),
        rating: require('@/assets/icons2026/c-rating.svg'),
        externalLink: require('@/assets/icons2026/external-link.svg'),
        chevronLeft: require('@/assets/icons2026/chevron-left.svg'),
        chevronRight: require('@/assets/icons2026/chevron-right.svg'),
        clock: require('@/assets/icons2026/clock.svg'),
        bClock: require('@/assets/icons2026/b-time.svg'),
        calendar: require('@/assets/icons2026/calendar.svg'),
        bCalendar: require('@/assets/icons2026/b-calendar.svg'),
        bLocation: require('@/assets/icons2026/b-location.svg'),
        bMapLocation: require('@/assets/icons2026/b-maps-location.svg'),
        createBooking: require('@/assets/icons2026/create-booking.svg')
      },
      weekdays: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
      thaiMonths: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
      scheduleMonth: moment().startOf('month'),
      useCalendarComponent: true,
      selectedMaid: null,
      maidOrders: [],
      scheduleLoading: false,
      selectedScheduleDay: null,
      placeholderAvatar: 'https://beneat.co/static/img/unknown.png',
      limitationOverride: undefined, // undefined = read from prop; string = locally saved value
      limitationAuditOverride: null, // { limitation_updated_at, name } after a local save
      toast: { open: false, variant: 'success', title: '', message: '' }
    }
  },
  computed: {
    ...mapState('admin', ['admin']),
    ...mapState('tag', ['tags']),
    ...mapState('professional', ['professionals']),
    ...mapState('aiAssistant', ['departmentIds', 'visionRequest']),
    canSeeAi () {
      return !!(this.admin && Array.isArray(this.departmentIds) &&
        this.departmentIds.includes(this.admin.department_id))
    },
    thaiMonthLabel () {
      return `${this.thaiMonths[this.scheduleMonth.month()]} ${this.scheduleMonth.year()}`
    },
    ordersByDayMap () {
      const map = {}
      this.maidOrders.forEach(o => {
        if (!o.cleaning_date) return
        const key = moment(o.cleaning_date).format('YYYY-MM-DD')
        if (!map[key]) map[key] = []
        map[key].push(o)
      })
      return map
    },
    calendarCells () {
      const start = this.scheduleMonth.clone().startOf('month')
      const daysInMonth = start.daysInMonth()
      const leading = start.day()
      const map = this.ordersByDayMap
      const cells = []
      for (let i = 0; i < leading; i++) {
        cells.push({ blank: true, key: 'blank-' + i })
      }
      for (let d = 1; d <= daysInMonth; d++) {
        const dateStr = start.clone().date(d).format('YYYY-MM-DD')
        cells.push({ blank: false, key: dateStr, day: d, dateStr, count: (map[dateStr] || []).length })
      }
      return cells
    },
    selectedDayOrders () {
      if (!this.selectedScheduleDay) return []
      return this.ordersByDayMap[this.selectedScheduleDay] || []
    },
    pro () {
      return (this.customer && this.customer.professional) ? this.customer.professional : null
    },
    convCustomer () {
      return (this.selectedConversation && this.selectedConversation.customer)
        ? this.selectedConversation.customer : null
    },
    // Guarded on the id so a missing one yields null, never ".../user/undefined".
    headerUserHref () {
      const id = this.convCustomer && this.convCustomer.beneat_user_id
      return id ? this.linkProfileUser(id) : null
    },
    proId () {
      return this.pro ? this.pro.id : null
    },
    avatarUrl () {
      const pic = this.pro && this.pro.picture
      if (!pic) return this.placeholderAvatar
      if (/^(https?:)?\/\//.test(pic)) return pic
      return `https://beneat.s3-ap-southeast-1.amazonaws.com/professionals/${pic}`
    },
    // Same icons the chat card puts before the name.
    headerStatusIcons () {
      const ids = this.selectedConversation && this.selectedConversation.status_icons
      return resolveStatusIcons(Array.isArray(ids) ? ids : [])
    },
    headerName () {
      const n = this.convCustomer && this.convCustomer.name
      if (n && String(n).trim()) return n
      return this.systemName
    },
    systemName () {
      return (this.pro && this.pro.full_name) ? this.pro.full_name : '-'
    },
    regionLabel () {
      return (this.pro && this.pro.province) ? this.pro.province.name_th : null
    },
    providerId () {
      return this.pro ? this.pro.id : null
    },
    // System record (read-only on the card) and chat copy (editable) are passed separately,
    // so the card can label each one. Empty values stay null; the card renders the placeholder.
    systemPhone () {
      return (this.pro && this.pro.phone) || null
    },
    systemEmail () {
      return (this.pro && this.pro.email) || null
    },
    chatPhone () {
      return (this.convCustomer && this.convCustomer.phone) || null
    },
    chatEmail () {
      return (this.convCustomer && this.convCustomer.email) || null
    },
    groupBadgeHtml () {
      if (!this.pro) return ''
      return this.$options.filters.professionalGroupId(this.pro.professional_group_id, this.pro.status)
    },
    isOnline () {
      return !!(this.pro && Number(this.pro.active) === 1)
    },
    statusRows () {
      return [
        { key: 'group', label: 'Group', html: this.groupBadgeHtml },
        {
          key: 'status',
          label: 'สถานะ',
          text: this.isOnline ? 'ออนไลน์' : 'ออฟไลน์',
          dot: this.isOnline ? 'online' : 'offline'
        }
      ]
    },
    inconveniencePets () {
      return (this.pro && Array.isArray(this.pro.inconvenience_pets)) ? this.pro.inconvenience_pets : []
    },
    partners () {
      return (this.pro && Array.isArray(this.pro.partners)) ? this.pro.partners : []
    },
    limitationText () {
      if (this.limitationOverride !== undefined) return this.limitationOverride
      return this.pro ? this.pro.limitation : null
    },
    limitationAudit () {
      if (this.limitationAuditOverride) return this.limitationAuditOverride
      const p = this.pro
      if (p && p.limitation_update_by_admin) {
        return { limitation_updated_at: p.limitation_updated_at, name: p.limitation_update_by_admin.name }
      }
      return null
    },
    latestOrder () {
      return (this.pro && this.pro.latest_order) ? this.pro.latest_order : null
    },
    channelBadge () {
      const type = this.selectedConversation ? this.selectedConversation.type : null
      switch (type) {
        case 'LineAtConversation':
        case 'LineProfessionalConversation':
          return { icon: this.icons.line, alt: 'LINE' }
        case 'PublicConversation':
          return { icon: this.icons.facebook, alt: 'Facebook' }
        default:
          return null
      }
    },
    // All four come from searchUser; a backend without a field (e.g. frontend deployed first)
    // leaves that tile as the old muted placeholder.
    stats () {
      const p = this.pro || {}
      const has = key => Object.prototype.hasOwnProperty.call(p, key)
      return [
        {
          label: 'Point',
          value: has('total_points') ? (parseFloat(p.total_points) || 0).toFixed(2) : 0,
          icon: this.icons.point,
          muted: !has('total_points'),
          hint: 'แต้มสะสมคงเหลือของแม่บ้านคนนี้ (ยังไม่หมดอายุ) ตรงกับหน้า Point History ในระบบแอดมิน'
        },
        {
          label: 'Booking',
          value: has('beneat_order_qty') ? Number(p.beneat_order_qty) || 0 : 0,
          icon: this.icons.booking,
          muted: !has('beneat_order_qty'),
          hint: 'จำนวนงานที่แม่บ้านคนนี้ทำเสร็จแล้ว (ไม่นับงานที่ยกเลิกหรือยังไม่ถึงวัน)'
        },
        {
          label: 'Review',
          value: has('review_qty') ? Number(p.review_qty) || 0 : 0,
          icon: this.icons.review,
          muted: !has('review_qty'),
          hint: 'จำนวนครั้งที่ลูกค้าให้คะแนนแม่บ้านคนนี้ (นับทุกครั้ง ทั้งที่เขียนและไม่เขียนคอมเมนต์)'
        },
        {
          label: 'Rating',
          value: p.avg_rating != null ? parseFloat(p.avg_rating).toFixed(1) : '—',
          icon: this.icons.rating,
          muted: !has('avg_rating'),
          hint: 'คะแนนเฉลี่ยที่ลูกค้าให้แม่บ้านคนนี้ จากทุกครั้งที่เคยได้รับคะแนน'
        }
      ]
    }
  },
  watch: {
    proId: {
      handler (id, oldId) {
        if (id) {
          this.seedMaidFromPro()
        }
        if (id !== oldId) {
          this.limitationOverride = undefined
          this.limitationAuditOverride = null
        }
      },
      immediate: true
    },
    visionRequest () {
      this.applyVisionRequest()
    }
  },
  // A request written before this panel mounted (collapsed column) never fires the watcher.
  mounted () {
    this.applyVisionRequest()
  },
  methods: {
    ...mapActions('professional', ['searchProfessionals']),
    // Pressing "ให้ AI วิเคราะห์รูป" in the chat lands the admin on the AI tab straight away.
    applyVisionRequest () {
      const request = this.visionRequest
      if (!request || !this.canSeeAi || request.token === appliedVisionToken) return
      appliedVisionToken = request.token
      this.activeTab = 4
    },
    showToast (variant, title, message) {
      this.toast = { open: true, variant, title, message }
    },
    onLimitationSaved (payload) {
      if (!payload) return
      this.limitationOverride = payload.value
      this.limitationAuditOverride = payload.audit
      if (this.pro) {
        this.pro.limitation = payload.value
        if (payload.audit) this.pro.limitation_updated_at = payload.audit.limitation_updated_at
      }
    },
    userAvatar (picture) {
      return picture !== null ? picture : 'https://beneat.co/static/img/unknown.png'
    },
    linkProfileProfessional (id) {
      return id !== null ? `https://admin-test.beneat.co/professional/${id}/profile` : null
    },
    // Sibling of linkProfileProfessional, same per-panel convention the other three panels use.
    linkProfileUser (id) {
      return id != null ? `https://admin-test.beneat.co/user/${id}` : null
    },
    setTab (n) {
      this.activeTab = n
    },
    seedMaidFromPro () {
      if (this.pro && this.pro.id) {
        this.selectedMaid = { id: this.pro.id, full_name: this.pro.full_name }
        this.selectedScheduleDay = null
        this.maidOrders = []
        this.fetchSchedule()
      }
    },
    async onSearchMaid (search, loading) {
      if (!search || !search.trim()) return
      loading(true)
      try {
        await this.searchProfessionals(search)
      } finally {
        loading(false)
      }
    },
    onSelectMaid (maid) {
      this.selectedMaid = maid
      this.selectedScheduleDay = null
      this.maidOrders = []
      if (maid) this.fetchSchedule()
    },
    async fetchSchedule () {
      if (!this.selectedMaid) return
      this.scheduleLoading = true
      try {
        const month = this.scheduleMonth.format('YYYY-MM')
        const { data } = await axios.get(`/beneat/professionals/${this.selectedMaid.id}/orders`, { params: { month } })
        this.maidOrders = (data && Array.isArray(data.data)) ? data.data : []
        // open on today's jobs when there are any; never override a day the admin already picked
        const today = moment().format('YYYY-MM-DD')
        if (!this.selectedScheduleDay && this.ordersByDayMap[today]) {
          this.selectedScheduleDay = today
        }
      } catch (e) {
        this.maidOrders = []
      } finally {
        this.scheduleLoading = false
      }
    },
    prevMonth () {
      this.scheduleMonth = this.scheduleMonth.clone().subtract(1, 'month')
      this.selectedScheduleDay = null
      this.fetchSchedule()
    },
    nextMonth () {
      this.scheduleMonth = this.scheduleMonth.clone().add(1, 'month')
      this.selectedScheduleDay = null
      this.fetchSchedule()
    },
    selectScheduleDay (cell) {
      this.selectedScheduleDay = cell.dateStr
    },
    onCalMonthChange (ym) {
      this.scheduleMonth = moment(ym, 'YYYY-MM').startOf('month')
      this.selectedScheduleDay = null
      this.fetchSchedule()
    },
    onCalSelectDay (dateStr) {
      this.selectedScheduleDay = dateStr
    },
    createBooking () {
      const params = { auto_fill: 1 }
      if (this.convCustomer && this.convCustomer.id) params.user_id = this.convCustomer.id
      if (this.selectedMaid) params.selected_professional_id = this.selectedMaid.id
      if (this.selectedScheduleDay) params.service_date = this.selectedScheduleDay
      const qs = new URLSearchParams(params).toString()
      const url = `https://admin-test.beneat.co/order/create-multiple?${qs}`
      window.open(url, '_blank')
    },
    maskStyle (url) {
      return {
        '-webkit-mask-image': 'url(' + url + ')',
        'mask-image': 'url(' + url + ')'
      }
    }
  }
}
</script>

<style scoped>
.v2026-professional-panel {
  --v2026-color-main: #31C1D7;
  --v2026-color-main-soft: #31C1D714;
  --v2026-color-icon-idle: #66696C;
  --v2026-link: #007bff;
  --v2026-surface: #ffffff;
  --v2026-surface-sunken: #F8FAFC;
  --v2026-surface-hover: #e9ecf1;
  --v2026-border: #e4e7ec;
  --v2026-text: #101828;
  --v2026-text-secondary: #667085;
  --v2026-text-muted: #98a2b3;
  --v2026-icon: #475467;
  --v2026-r-card: 12px;
  --v2026-r-box: 14px;
  --v2026-r-tab: 10px;
  --v2026-sp-1: 4px;
  --v2026-sp-2: 8px;
  --v2026-sp-3: 12px;
  --v2026-sp-4: 16px;
  --v2026-sp-5: 20px;
  --v2026-sp-6: 24px;
  --v2026-fs-section: 13px;
  --v2026-fs-body: 14px;
  --v2026-fs-meta: 12px;
  --v2026-fs-name: 16px;

  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-4);
  height: 100%;
  overflow: hidden;
  background: var(--v2026-surface);
  padding: 0;
}

.v2026-pp-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: var(--v2026-sp-6);
}

.v2026-pp-mask {
  display: inline-block;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-icon);
}

.v2026-pp-section-label {
  font-size: var(--v2026-fs-section);
  font-weight: 600;
  color: var(--v2026-text-secondary);
}

.v2026-pp-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.v2026-pp-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
}
.v2026-pp-icon-btn:hover {
  background: var(--v2026-surface-hover);
}
.v2026-pp-icon-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}

.v2026-pp-edit {
  width: 16px;
  height: 16px;
  background-color: var(--v2026-icon);
}

.v2026-pp-link {
  color: var(--v2026-link);
  text-decoration: none;
  font-size: var(--v2026-fs-body);
}
.v2026-pp-link:hover {
  text-decoration: underline;
}
.v2026-pp-link:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
  border-radius: 3px;
}

.v2026-pp-tabpane {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-4);
}

.v2026-pp-notes {
  padding: var(--v2026-sp-4) var(--v2026-sp-4) 0;
}

.v2026-pp-maidpick {
  margin-bottom: var(--v2026-sp-3);
  font-size: var(--v2026-fs-body);
}
.v2026-pp-cal__create {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--v2026-sp-2);
  width: 100%;
  margin-top: var(--v2026-sp-3);
  padding: var(--v2026-sp-3);
  border: 1px solid var(--v2026-color-main);
  border-radius: 8px;
  background: rgba(49, 193, 215, 0.08);
  color: var(--v2026-color-main);
  font-size: var(--v2026-fs-body);
  font-weight: 600;
  cursor: pointer;
}
.v2026-pp-cal__create:hover { background: rgba(49, 193, 215, 0.18); }
.v2026-pp-cal__create-ico {
  width: 18px;
  height: 18px;
  background-color: currentColor;
}

.v2026-pp-lastorder { margin-top: var(--v2026-sp-4); }

.v2026-pp-bookings {
  padding: var(--v2026-sp-4) var(--v2026-sp-4) 0;
  gap: var(--v2026-sp-3);
}
.v2026-pp-cal {
  padding: var(--v2026-sp-3);
}
.v2026-pp-cal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--v2026-sp-2);
}
.v2026-pp-cal__title {
  font-size: var(--v2026-fs-body);
  font-weight: 600;
  color: var(--v2026-text);
}
.v2026-pp-cal__nav {
  width: 18px;
  height: 18px;
  background-color: var(--v2026-icon);
}
.v2026-pp-cal__weekdays,
.v2026-pp-cal__grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}
.v2026-pp-cal__weekday {
  text-align: center;
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-muted);
  padding: var(--v2026-sp-1) 0;
}
.v2026-pp-cal__cell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  border: 0;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
  transition: background 150ms ease;
}
.v2026-pp-cal__cell--empty {
  cursor: default;
}
.v2026-pp-cal__cell:not(.v2026-pp-cal__cell--empty):hover {
  background: var(--v2026-surface-hover);
}
.v2026-pp-cal__cell:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}
.v2026-pp-cal__num {
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text);
}
.v2026-pp-cal__cell.is-selected {
  box-shadow: inset 0 0 0 2px var(--v2026-color-main);
}
.v2026-pp-cal__cell.is-selected .v2026-pp-cal__num {
  color: var(--v2026-color-main);
  font-weight: 700;
}
.v2026-pp-cal__dots {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 2px;
}
.v2026-pp-cal__dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
}
.v2026-pp-cal__dot--accent {
  background: var(--v2026-color-main);
}
.v2026-pp-cal__dot--more {
  width: 6px;
  height: 6px;
  background: #1a8ea3;
}

.v2026-pp-booking {
  background: var(--v2026-surface-sunken);
  border-radius: var(--v2026-r-card);
  padding: var(--v2026-sp-3);
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-2);
}
.v2026-pp-booking__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--v2026-sp-2);
}
.v2026-pp-booking__ids {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--v2026-sp-2);
  min-width: 0;
}
.v2026-pp-booking__id {
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-muted);
}
.v2026-pp-booking__service {
  font-size: var(--v2026-fs-body);
  font-weight: 600;
  color: var(--v2026-text);
}
.v2026-pp-booking__row {
  display: flex;
  align-items: flex-start;
  gap: var(--v2026-sp-2);
}
.v2026-pp-booking__ico {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  margin-top: 1px;
  background-color: var(--v2026-color-main);
}
.v2026-pp-booking__text {
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-secondary);
  line-height: 1.5;
  word-break: break-word;
}
.v2026-pp-booking__text--danger {
  color: #f04438;
}

.v2026-pp-dot {
  color: var(--v2026-text-muted);
}

.v2026-pp-important {
  padding: 0 var(--v2026-sp-4);
}
.v2026-pp-important__box {
  margin-top: var(--v2026-sp-2);
  background: var(--v2026-surface-sunken);
  border-radius: var(--v2026-r-box);
  padding: var(--v2026-sp-3) var(--v2026-sp-4);
  font-weight: 700;
  color: var(--v2026-text);
  font-size: var(--v2026-fs-body);
  line-height: 1.5;
}

.v2026-pp-card {
  background: var(--v2026-surface-sunken);
  border-radius: var(--v2026-r-card);
}

.v2026-pp-system {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-2);
  padding: 0 var(--v2026-sp-4);
}

.v2026-pp-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--v2026-sp-2);
  padding: 0 var(--v2026-sp-4);
}
.v2026-pp-stat {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-1);
  padding: var(--v2026-sp-3);
}

.v2026-pp-stat.is-muted {
  opacity: 0.55;
}
.v2026-pp-stat__top {
  display: flex;
  align-items: center;
  gap: var(--v2026-sp-2);
}
.v2026-pp-stat__ico {
  width: 18px;
  height: 18px;
  background-color: var(--v2026-color-main);
}
.v2026-pp-stat.is-muted .v2026-pp-stat__ico {
  background-color: var(--v2026-text-muted);
}
.v2026-pp-stat__label {
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-secondary);
}
.v2026-pp-stat__hint {
  margin-left: auto;
  font-size: 12px;
  color: var(--v2026-text-secondary);
  cursor: help;
}
.v2026-pp-stat__value {
  font-size: 20px;
  font-weight: 700;
  color: var(--v2026-text);
}

</style>
